import { createListenerMiddleware, addListener } from '@reduxjs/toolkit';
import type { TypedStartListening, TypedAddListener } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';

export const listenerMiddleware = createListenerMiddleware();

export type AppStartListening = TypedStartListening<RootState>;

export const startAppListening = listenerMiddleware.startListening as AppStartListening;

export const addAppListener = addListener as TypedAddListener<RootState>;
